import { useRef, useCallback } from "react";
import { Animations } from "./animations.enum";

const animationsMap: Record<Animations, [Keyframe[], KeyframeAnimationOptions]> = {
  [Animations.Heartbeat]: [
    [{ transform: "scale(1)" }, { transform: "scale(1.1)" }, { transform: "scale(1)" }, { transform: "scale(1.1)" }, { transform: "scale(1)" }],
    {
      duration: 700,
      easing: "ease-in-out",
    },
  ],
  [Animations.Wiggle]: [
    [
      { transform: "rotate(-10deg) scale(0.9)" },
      { transform: "rotate(10deg) scale(1)" },
      { transform: "rotate(-5deg) scale(1.1)" },
      { transform: "rotate(0deg) scale(1)" },
    ],
    {
      duration: 1500,
      easing: "ease-in-out",
    },
  ],
};

export function useAnimation(animation: Animations) {
  const targetRef = useRef<HTMLDivElement>(null);
  const isAnimating = useRef(false);

  const trigger = useCallback(() => {
    const el = targetRef.current;
    if (!el || isAnimating.current) return;

    isAnimating.current = true;

    const [keyframes, options] = animationsMap[animation];
    const anim = el.animate(keyframes, options);

    anim.onfinish = () => {
      isAnimating.current = false;
    };
  }, [animation]);

  return { targetRef, isAnimating, trigger };
}
